/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-down': {
    width: 32,
    height: 18,
    viewBox: '0 0 32 18',
    data: '<path pid="0" d="M0 2.23c0 .619.222 1.145.667 1.579l13.81 13.47c1.015.991 2.063.96 3.142-.093L31.333 3.81c.445-.434.667-.96.667-1.58 0-.619-.222-1.145-.667-1.579A2.233 2.233 0 0029.714 0c-.635 0-1.174.217-1.619.65L16 12.45 3.905.65A2.233 2.233 0 002.285 0C1.652 0 1.112.217.668.65.222 1.084 0 1.61 0 2.23z" _fill="#000" fill-rule="nonzero"/>'
  }
})
